import type { CatalogService } from '../../gql-operations/gql-generated';
import { COUNT_MAX, ICON_URL_FALLBACK } from '../components/ServicesOffered/constants';
import type { Service } from '../components/ServicesOffered/types';

export const mapServices = (services: CatalogService[]): Service[] =>
    services
        .map((service) => ({
            id: service.id,
            name: service.displayName.value,
            iconUrl: service.iconUrl || ICON_URL_FALLBACK,
        }))
        .slice(0, COUNT_MAX);
